import '../../css/mk-brand.css';
import {useEffect} from "react";
import BattleKitchen from '../../media/Banner-Transparent-Home2.jpg';

function Panel() {
  useEffect(() => {}, );
  return (
      <div id="mk-battle-kitchen" className="m-2">
        <div className="container bg-zinc-800 pt-4 px-4 pb-4 rounded-lg max-w-4xl">
          <div className="flex flex-col">
            <h2 className="flex mx-auto">
              <h2 className="mb-2 md:text-6xl text-3xl font-extrabold leading-none">
                m
              </h2>
              <h2 className="mb-2 md:text-6xl text-3xl font-extrabold leading-none">
                K
              </h2>
              <h2 className="mb-2 md:text-6xl text-3xl font-extrabold leading-none text-brand">
                Battle
              </h2>
              &nbsp;
              <h2 className="mb-2 md:text-6xl text-3xl font-extrabold leading-none text-brand-text">
                Kitchen
              </h2>
            </h2>
            <div className="mx-auto max-w-sm md:max-w-xl">
              <img src={BattleKitchen} className="" />
            </div>
            <div className="">
              <p className="p-4 mb-6 text-white md:text-2xl">
                mKBattle Kitchen is a blockchain PvP cooking battle game that crosses a head-2-head Pokemon colosseum style battle format with our favorite cooking shows (Food Wars! Shokugeki no Soma, Iron Chef). Chefs will leverage their NFT assets and put them on the line against other chefs for culinary glory and delicious rewards.
                Think, strategize and create the best combination of in-game assets to defeat your opponent. Earn experience and $CHEF coins while trying to reach the top of the culinary world.
              </p>
              <hr />
              <div className="flex justify-between">
                <div>multi-player</div>&#183;
                <div>multi-NFT</div>&#183;
                <div>multi-round</div>&#183;
                <div>multi-arena</div>&#183;
                <div>player rankings</div>
              </div>
              <hr />
            </div>

          </div>
        </div>
      </div>
  );
}

export default Panel;